import { createSlice } from "@reduxjs/toolkit";

const initialState:UIDocumentos = {
    pastas: [],
    documentos: [],
    caminho: [],
    documentoDados: {},
    loadingPasta: false,
}
export interface UIDocumentos {
    pastas: any[]
    documentos: any[]
    caminho: any[]
    documentoDados: any
    loadingPasta: boolean
}
export interface iDocsSelecionados {
    documentos: string[]
    pastas: number[]
}

export const documentosSlice = createSlice({
    name: "uiDocumentos",
    initialState,
    reducers: {
        loadingPasta: (state, action) => { 
            state.loadingPasta = action.payload.status
        },
        atualizar: (state, action) => {
            state.documentos = action.payload.documentos
            state.pastas = action.payload.pastas
            state.caminho = action.payload.caminho
        },
        selecionarPasta: (state, action) => {
            // state.selecionados.pastas = action.payload.pastas
            const id_pasta = action.payload.id_pasta
            const ativo:boolean = action.payload.ativo
            if (ativo) {
                let verificarExiste = state.pastas.findIndex(reg => reg.id_pasta === id_pasta)
                if (verificarExiste >= 0) {
                    state.pastas[verificarExiste]['selecionado'] = true
                }
                // state.selecionados.pastas.push(id_pasta)
            }
            if (!ativo) {
                let verificarExiste = state.pastas.findIndex(reg => reg.id_pasta === id_pasta)
                if (verificarExiste >= 0) {
                    state.pastas[verificarExiste]['selecionado'] = false
                }
                // let verificarExiste = state.selecionados.pastas.filter(reg => reg === id_pasta)
                // if (verificarExiste.length > 0) {
                //     state.selecionados.pastas = state.selecionados.pastas.filter(reg => reg !== id_pasta)
                // }
            }
        },
        selecionarDocumento: (state, action) => {
            const codigo = action.payload.codigo
            const ativo:boolean = action.payload.ativo
            if (ativo) {
                let verificarExiste = state.documentos.findIndex(reg => reg.codigo === codigo)
                if (verificarExiste >= 0) {
                    state.documentos[verificarExiste]['selecionado'] = true
                }
            }
            if (!ativo) {
                let verificarExiste = state.documentos.findIndex(reg => reg.codigo === codigo)
                if (verificarExiste >= 0) {
                    state.documentos[verificarExiste]['selecionado'] = false
                }
            }
        },
        setDocumentoDados: (state, action) => { 
            state.documentoDados = action.payload.documento
        }
    }
})

export const { atualizar, selecionarDocumento, selecionarPasta, setDocumentoDados, loadingPasta } = documentosSlice.actions

export default documentosSlice.reducer
